import styles from "./post.module.css";
import {useEffect, useState} from "react";
import {useApp} from "../../context/AppDataContext";
import axios from "axios";
import {Select, Button, Input} from "antd";
import TextArea from "antd/es/input/TextArea";
import {CloseOutlined, PlusOutlined} from "@ant-design/icons";
import {useAuth} from "../../context/AppAuthContext";


export default function Post() {
    const {isLoading, setIsLoading, error} = useApp();
    const {submitListing} = useAuth();

    const [filtersData, setFiltersData] = useState(null);

    // FILTERS SELECTION DATA
    const [tradeTypes, setTradeTypes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [conditions, setConditions] = useState([]);

    // USER SELECTION DATA
    const [selectedTradeType, setSelectedTradeType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCondition, setSelectedCondition] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [images, setImages] = useState([]);

    useEffect(() => {
        async function getFilters() {
            setIsLoading(true);
            try {
                const res = await axios.get('/filters/');
                setFiltersData(res.data);
            } catch (err) {
                error("An error occurred when fetching the filters");
                console.error(err);
                setFiltersData(null);
            } finally {
                setIsLoading(false);
            }
        }

        getFilters();
    }, []);

    function submitPost() {
        // SUBMIT CHECK
        if (description.length < 1 || title.length < 1) {
            error("Please enter the post title and description");
            return;
        }
        if (images.length === 0) {
            error("Please upload at least one image");
            return;
        }
        // console.log(
        //     "title: ", title,
        //     "description: ", description,
        //     "trade type: ", selectedTradeType,
        //     "condition: ", selectedCondition,
        //     "category: ", selectedCategory
        // )
        const listingObject = {
            category_id: selectedCategory.value,
            condition: selectedCondition,
            description: description,
            title: title,
            trade_type: selectedTradeType,
            listing_images: images
        }
        submitListing(listingObject);
    }

    useEffect(() => {
        if (filtersData) {
            // Transform trade types
            const newTradeTypes = filtersData.tradetype.filters.map(filter => filter.name);
            setTradeTypes(newTradeTypes);

            // Transform categories
            const newCategories = filtersData.categories.map(filter => ({
                label: filter.name,
                value: filter.id
            }));
            setCategories(newCategories);

            // Transform conditions
            const newConditions = filtersData.condition.filters.map(filter => filter.name);
            setConditions(newConditions);

            // Set default selections
            if (newTradeTypes.length > 0) setSelectedTradeType(newTradeTypes[0]);
            if (newCategories.length > 0) setSelectedCategory(newCategories[0]);
            if (newConditions.length > 0) setSelectedCondition(newConditions[0]);
        }
    }, [filtersData]);

    const fileDataURL = file => new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = reject;
        fr.readAsDataURL(file)
    });

    function showResult(file) {
        // SET A LIMIT OF 5 IMAGES
        if (images.length >= 5) {
            error("You reached the post images limit!");
            return;
        }
        fileDataURL(file)
            .then(data => {
                if (data.includes("image") && data.includes("png")) {
                    setImages((prev) => [...prev, data])
                }
            })
            .catch(err => console.log(err));
    }

    return (
        !isLoading &&
        <div className={styles.post}>
            <Input
                autoFocus
                onChange={(e) => setTitle(e.target.value)}
                value={title}
                placeholder={"Title..."}
                className={styles.title}
            />
            {filtersData && categories.length > 0 && (
                <FiltersPanel
                    tradeTypes={tradeTypes}
                    categories={categories}  // Fixed prop name
                    conditions={conditions}
                    selectedTradeType={selectedTradeType}
                    selectedCategory={selectedCategory}
                    selectedCondition={selectedCondition}
                    setSelectedTradeType={setSelectedTradeType}
                    setSelectedCondition={setSelectedCondition}
                    setSelectedCategory={setSelectedCategory}
                />
            )}
            <TextArea
                placeholder="Description..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{maxWidth: 800}}
                autoSize={{minRows: 3}}
                className={styles.description}
            />
            <ImageUploadSection images={images} setImages={setImages} showResult={showResult}/>
            <Button className={styles.submit_button} type={"primary"} onClick={submitPost}>Post</Button>
        </div>
    )
}

function ImageUploadSection({images, setImages, showResult}) {
    return (
        <div className={styles.image_upload_section}>
            {images.length < 5 && (
                <>
                    <label htmlFor="file-upload" className={styles.custom_file_upload}>
                        + Upload Image
                    </label>
                    <input
                        id="file-upload"
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={(e) => e.target.files[0] && showResult(e.target.files[0])}
                        className={styles.hidden_input}
                    />
                </>
            )}

            <div className={styles.image_preview_container}>
                {images.map((image, index) => (
                    <div className={styles.image_card} key={index}>
                        <img className={styles.image} src={image} alt={`image-${index}`}/>
                        <Button
                            color="danger"
                            variant="solid"
                            className={styles.remove_image}
                            onClick={(e) => setImages(images.filter((item) => item !== image))}
                            icon={<CloseOutlined/>}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

function FiltersPanel({
                          tradeTypes,
                          categories,
                          conditions,
                          selectedTradeType,
                          selectedCategory,
                          selectedCondition,
                          setSelectedTradeType,
                          setSelectedCondition,
                          setSelectedCategory
                      }) {
    return (
        <div className={styles.filters_panel}>
            {/* Category Select */}
            <Select
                value={selectedCategory?.value}  // Use value instead of label
                onChange={(value) => {
                    const selected = categories.find(cat => cat.value === value);
                    setSelectedCategory(selected);
                }}
                options={categories}
                placeholder="Select category"
                className={styles.filter_select}
            />

            {/* Trade Type Select */}
            <Select
                value={selectedTradeType}
                onChange={setSelectedTradeType}
                options={tradeTypes.map(type => ({value: type, label: type}))}
                placeholder="Select trade type"
                className={styles.filter_select}
            />

            {/* Condition Select */}
            <Select
                value={selectedCondition}
                onChange={setSelectedCondition}
                options={conditions.map(cond => ({value: cond, label: cond}))}
                placeholder="Select condition"
                className={styles.filter_select}
            />
        </div>
    )
}